import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import React, { useEffect, useState } from 'react'
import Bullet from '../../../images/BulletPoint.svg'

enum ImageSide {
  Left = 'left',
  Right = 'right'
}

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundImage: any
  imageSide: ImageSide
  builderImage: any
  builderMobileImage: any
  imageMaxWidth: boolean
  imageAltText: string
  imageBackdropColor: string
  contentText: string
  textAlignment: Alignment
  bulletPoint: any
  bulletAltText: string
  points: [{ text: string }]
  contextFooter: string
  centered: boolean
  xlScreenContainer: boolean
}

const TextImageLandingPage = ({
  backgroundImage = '',
  imageSide,
  builderImage,
  builderMobileImage,
  imageMaxWidth,
  imageAltText = '',
  imageBackdropColor,
  contentText,
  textAlignment,
  bulletPoint,
  bulletAltText = '',
  points,
  contextFooter,
  centered,
  xlScreenContainer
}: Props) => {
  const [isLargeScreen, setIsLargeScreen] = useState(true)

  const handleWindowSizeChange = () => {
    if (window.innerWidth > 1444) {
      setIsLargeScreen(true)
    } else {
      setIsLargeScreen(false)
    }
  }

  useEffect(() => {
    handleWindowSizeChange()
    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const signatureIndex = contextFooter?.lastIndexOf(',')
  const founder = signatureIndex > 0 && contextFooter.slice(0, signatureIndex + 1).trim()
  const oraganization = signatureIndex > 0 && contextFooter.slice(signatureIndex + 1, contextFooter.length).trim()

  const getContent = () => {
    if (imageSide === ImageSide.Left) {
      return (
        <>
          <div className="lg:absolute lg:inset-0">
            <div className="top-auto lg:absolute lg:inset-y-0 lg:left-0 lg:top-1/2 lg:h-full lg:w-1/2 lg:-translate-y-1/2">
              <CdnImage
                className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                url={builderImage}
                alt={imageAltText}
                steps={[705]}
                style={{
                  width: '705px',
                  height: '1275px',
                  maxHeight: '100%',
                  maxWidth: '100%'
                }}
              />
              <CdnImage
                className="block object-contain lg:absolute lg:hidden"
                url={builderMobileImage}
                alt={imageAltText}
                steps={[480]}
                style={{
                  width: '100%',
                  height: '100%',
                  maxHeight: '18rem'
                }}
              />
            </div>
          </div>

          <div className="relative h-full w-full px-4 pt-4 pb-6 sm:px-6 sm:pt-16 md:pt-12 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:px-8">
            <div className="col-span-2 lg:col-start-2 lg:pl-8">
              <div className="word-break-fix mx-auto max-w-prose text-base lg:ml-auto lg:mr-0">
                <div className="prose prose-indigo mt-5 text-gray-500">
                  <p
                    className={`enable-list-styles h-full w-full text-base ${getAlignmentClass()}`}
                    dangerouslySetInnerHTML={{ __html: contentText }}
                  ></p>
                </div>
                <div className="max-h-ful mt-4 mb-4 flex max-w-full flex-col gap-y-3">
                  {points?.map((point, i) => (
                    <div className="flex items-center" key={i}>
                      <img src={bulletPoint || Bullet} className="mr-2 h-8 w-8" alt={bulletAltText} />
                      <p className="text-left font-normal text-black  lg:text-center">{point.text}</p>
                    </div>
                  ))}
                </div>
                <div className="font-third max-h-full max-w-full text-3xl text-black sm:text-5xl lg:ml-10">
                  {signatureIndex > 0 ? (
                    <>
                      <p>{founder}</p>
                      <p>{oraganization}</p>
                    </>
                  ) : (
                    contextFooter
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div
          className={`mx-auto flex h-full ${centered ? 'w-full lg:!w-3/4 2xl:!w-4/6' : `w-full ${xlScreenContainer ? '2xl:w-3/4' : ''}`} flex-col lg:flex-row 2xl:container`}
        >
          <div className="mx-auto h-full max-h-[1000px] min-h-[24rem] w-full justify-center pt-4 lg:pt-8 text-center lg:mt-16 lg:w-1/2 lg:text-left">
            <div className={`col-span-2 lg:col-start-1 ${centered ? 'pr-4 2xl:pl-20' : 'lg:pl-8'}`}>
              <div className="word-break-fix mx-auto max-w-prose text-base lg:mr-auto lg:ml-0 ">
                <div className="prose prose-indigo mt-5 text-gray-500 ">
                  <p
                    className={`enable-list-styles text-center text-base lg:text-left ${getAlignmentClass()}`}
                    dangerouslySetInnerHTML={{ __html: contentText }}
                  ></p>
                </div>
                <div className="mx-auto mt-4 mb-4 flex max-h-full max-w-full flex-col gap-y-3 md:ml-10 md:gap-y-1 lg:ml-0">
                  {points?.map((point, i) => (
                    <div className="flex items-center" key={i}>
                      <img src={bulletPoint || Bullet} className="mr-2 h-8 w-8" alt={bulletAltText} />
                      <p className="text-left font-normal text-base">{point.text}</p>
                    </div>
                  ))}
                </div>
                <div className="font-third max-h-full max-w-full text-3xl text-black sm:text-5xl lg:ml-10 lg:pb-2">
                  {signatureIndex > 0 ? (
                    <>
                      <p>{founder}</p>
                      <p>{oraganization}</p>
                    </>
                  ) : (
                    contextFooter
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 w-full lg:w-1/2 lg:pt-8 block">
            <div
              className={`max-h-448 relative mx-auto mb-12 h-auto ${
                centered ? 'w-full flex justify-center items-center' : 'w-[85%] flex justify-center'
              } rounded-lg lg:h-[24rem]`}
            >
              <div
                className={`image-backdrop-square-wrapper absolute inset-0 flex justify-center mx-auto rounded-[30px] lg:h-[25rem] z-0 ${!isLargeScreen ? '' : 'md:max-w-[35rem]'}`}
                style={{ backgroundColor: imageBackdropColor }}
              />
              {!isLargeScreen ? (
                <CdnImage
                  className="height-specifier relative z-10 h-full rounded-[30px] object-cover"
                  url={builderImage}
                  alt={imageAltText}
                  steps={[315, 390, 515, 640]}
                  style={{ maxWidth: imageMaxWidth ? '' : '' }}
                />
              ) : (
                <CdnImage
                  className="height-specifier relative z-10 h-full rounded-[30px] object-cover"
                  url={builderImage}
                  alt={imageAltText}
                  steps={[315, 390, 515, 640]}
                  style={{ maxWidth: imageMaxWidth ? '35rem' : '' }}
                />
              )}
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div
        className="relative mx-auto flex w-11/12 flex-col items-center justify-center bg-white bg-auto bg-no-repeat lg:flex-row lg:bg-100%"
        style={{ backgroundImage: `url(${backgroundImage ?? ''})` }}
      >
        {getContent()}
      </div>
    </>
  )
}

export default TextImageLandingPage

Builder.registerComponent(TextImageLandingPage, {
  name: 'TextImageLandingPage',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'imageSide',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageMaxWidth',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'bulletPoint',
      type: 'file',
      defaultValue: Bullet
    },
    {
      name: 'bulletAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'points',
      type: 'list',
      subFields: [{ name: 'text', type: 'string' }],
      defaultValue: []
    },
    {
      name: 'contextFooter',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'centered',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'xlScreenContainer',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
